import React from 'react';

import CombinedText from '../../components/CombinedText';
import * as renderSensor from '../../components/sensors';
import config from '../../config';

export default class Scrolling extends React.Component {
  state = {
    index: 0,
  }
  componentDidMount() {
    this.interval = setInterval(() => {
      const nextIndex = this.state.index + 1;
      this.setState({ index: nextIndex < this.props.config.screens.length ? nextIndex : 0 })
    }, config.cycleInterval)
  }
  render() {
    const screen = this.props.config.screens[this.state.index];
    return (
      <CombinedText
        size={this.props.size}
        keys={screen.keys}
        renderValues={screen.keys.map(key => renderSensor[key] || renderSensor.generic(key))}
        extraRotation={0}
      />
    )
  }
  
}




// WEBPACK FOOTER //
// ./src/plots/Scrolling/Scrolling.component.js